// Style options configuration for different product types

const img = (key, fallback) =>
  (window.foxQuoteFormImages && window.foxQuoteFormImages[key]) || fallback;

const BASE_URL = 'https://foxwindowsanddoors.com/app/uploads/form';

export const styleOptions = {
  conservatories: [
    {
      id: 'traditional-extension',
      title: 'Traditional Extension',
      image: img('conservatory_style_traditional_extension', `${BASE_URL}/conservatories/styles/traditional-extension.jpg`),
    },
    {
      id: 'contemporary-extension',
      title: 'Contemporary Extension',
      image: img('conservatory_style_contemporary_extension', `${BASE_URL}/conservatories/styles/contemporary-extension.jpg`),
    },
    {
      id: 'contemporary-orangery',
      title: 'Contemporary Orangery',
      image: img('conservatory_style_contemporary_orangery', `${BASE_URL}/conservatories/styles/contemporary-orangery.jpg`),
    },
    {
      id: 'orangery',
      title: 'Traditional Orangery',
      image: img('conservatory_style_orangery', `${BASE_URL}/conservatories/styles/traditional-orangery.jpg`),
    },
    {
      id: 'conservatory',
      title: 'Traditional Conservatory',
      image: img('conservatory_style_conservatory', `${BASE_URL}/conservatories/styles/traditional-conservatory.jpg`),
    },
    {
      id: 'contemporary-conservatory',
      title: 'Contemporary Conservatory',
      image: img('conservatory_style_contemporary_conservatory', `${BASE_URL}/conservatories/styles/glazed-extension.jpg`),
    },
  ],

  windows: [
    {
      id: 'aluminium',
      title: 'Aluminium',
      image: img('windows_style_aluminium', `${BASE_URL}/windows/styles/aluminium.jpg`),
    },
    {
      id: 'flush-casement',
      title: 'Flush Casement',
      image: img('windows_style_flush_casement', `${BASE_URL}/windows/styles/flush-casement.jpg`),
    },
    {
      id: 'upvc',
      title: 'uPVC',
      image: img('windows_style_upvc', `${BASE_URL}/windows/styles/upvc.jpg`),
    },
    {
      id: 'secondary-glazing',
      title: 'Secondary Glazing',
      image: img('windows_style_secondary_glazing', `${BASE_URL}/windows/styles/secondary-glazing.jpg`),
    },
  ],

  'aluminium-windows': [
    {
      id: 'standard-frame',
      title: 'Standard Frame',
      image: img('windows_aluminium_substyle_standard_frame', `${BASE_URL}/windows/aluminium-substyles/standard-frame.jpg`),
    },
    {
      id: 'slim-frame',
      title: 'Slim Frame',
      image: img('windows_aluminium_substyle_slim_frame', `${BASE_URL}/windows/aluminium-substyles/slim-frame.jpg`),
    },
    {
      id: 'steel-look-no-bars',
      title: 'Steel Look (No Bars)',
      image: img('windows_aluminium_substyle_steel_look_no_bars', `${BASE_URL}/windows/aluminium-substyles/steel-look-no-bars.jpg`),
    },
    {
      id: 'steel-look-horizontal-bars',
      title: 'Steel Look (Horizontal Bars)',
      image: img('windows_aluminium_substyle_steel_look_horizontal_bars', `${BASE_URL}/windows/aluminium-substyles/steel-look-horizontal-bars.jpg`),
    },
    {
      id: 'steel-look-georgian-style',
      title: 'Steel Look (Georgian Style)',
      image: img('windows_aluminium_substyle_steel_look_georgian', `${BASE_URL}/windows/aluminium-substyles/steel-look-georgian.jpg`),
    },
  ],

  'internal-products': [
    {
      id: 'internal-single-door-full-glass',
      title: 'Internal Single Door (Full Glass)',
      image: img('internal_products_style_single_door_full_glass', `${BASE_URL}/internal-products/styles/single-door-full-glass.jpg`),
    },
    {
      id: 'internal-single-door-horizontal-bars',
      title: 'Internal Single Door (Horizontal Bars)',
      image: img('internal_products_style_single_door_horizontal_bars', `${BASE_URL}/internal-products/styles/single-door-horizontal-bars.jpg`),
    },
    {
      id: 'internal-french-doors-full-glass',
      title: 'Internal French Doors (Full Glass)',
      image: img('internal_products_style_french_doors_full_glass', `${BASE_URL}/internal-products/styles/internal-french-doors.webp`),
    },
    {
      id: 'internal-french-doors-horizontal-bars',
      title: 'Internal French Doors (Horizontal Bars)',
      image: img('internal_products_style_french_doors_horizontal_bars', `${BASE_URL}/internal-products/styles/french-doors-horizontal-bars.jpg`),
    },
    {
      id: 'internal-combination-frames',
      title: 'Internal Combination Frames',
      image: img('internal_products_style_combination_frames', `${BASE_URL}/internal-products/styles/combination-frames.jpeg`),
    },
    {
      id: 'internal-windows',
      title: 'Internal Windows',
      image: img('internal_products_style_internal_windows', `${BASE_URL}/internal-products/styles/internal-windows.jpg`),
    },
    {
      id: 'internal-sliding-door',
      title: 'Internal Sliding Door',
      image: img('internal_products_style_internal_sliding_door', `${BASE_URL}/internal-products/styles/internal-sliding-door.webp`),
    },
    {
      id: 'internal-pocket-door',
      title: 'Internal Pocket Door',
      image: img('internal_products_style_internal_pocket_door', `${BASE_URL}/internal-products/styles/internal-pocket-door.jpg`),
    },
  ],

  'front-back-doors': [
    {
      id: 'composite-doors-front-back',
      title: 'Composite Doors',
      image: img('front_back_doors_style_composite_doors', `${BASE_URL}/front-back-doors/styles/composite-doors.jpg`),
    },
    {
      id: 'composite-stable-doors',
      title: 'Composite Stable Doors',
      image: img('front_back_doors_style_composite_stable_doors', `${BASE_URL}/front-back-doors/styles/composite-stable-doors.jpg`),
    },
    {
      id: 'glass-doors',
      title: 'Glass Doors',
      image: img('front_back_doors_style_glass_doors', `${BASE_URL}/front-back-doors/styles/aluminium-full-glass-doors.jpg`),
    },
    {
      id: 'aluminium-residential-doors',
      title: 'Aluminium Residential Doors',
      image: img('front_back_doors_style_aluminium_residential_doors', `${BASE_URL}/front-back-doors/styles/aluminium-residential-doors.jpg`),
    },
    {
      id: 'aluminium-pivot-doors',
      title: 'Aluminium Pivot Doors',
      image: img('front_back_doors_style_aluminium_pivot_doors', `${BASE_URL}/front-back-doors/styles/aluminium-pivot-doors.jpg`),
    },
    {
      id: 'steel-look-doors',
      title: 'Steel Look Doors',
      image: img('front_back_doors_style_steel_look_doors', `${BASE_URL}/front-back-doors/styles/steel-look-doors.jpg`),
    },
  ],

  'aluminium-doors': [
    {
      id: 'aluminium-glass-doors',
      title: 'Aluminium Glass Doors',
      image: img('aluminium_doors_style_glass_doors', `${BASE_URL}/aluminium-doors/styles/aluminium-glass-doors.jpg`),
    },
    {
      id: 'aluminium-residential-doors',
      title: 'Aluminium Residential Doors',
      image: img('aluminium_doors_style_residential_doors', `${BASE_URL}/aluminium-doors/styles/aluminium-residential-doors.jpg`),
    },
    {
      id: 'aluminium-pivot-doors',
      title: 'Aluminium Pivot Doors',
      image: img('aluminium_doors_style_pivot_doors', `${BASE_URL}/aluminium-doors/styles/aluminium-pivot-doors.jpg`),
    },
    {
      id: 'steel-look-doors',
      title: 'Steel Look Doors',
      image: img('aluminium_doors_style_steel_look_doors', `${BASE_URL}/aluminium-doors/styles/steel-look-doors.jpg`),
    },
  ],

  'bifolding-sliding-french-doors': [
    {
      id: 'aluminium-sliding-doors',
      title: 'Aluminium Sliding Doors',
      image: img('bifolding_style_aluminium_sliding_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/aluminium-sliding-doors.jpg`),
    },
    {
      id: 'aluminium-french-doors',
      title: 'Aluminium French Doors',
      image: img('bifolding_style_aluminium_french_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/aluminium-french-doors.jpg`),
    },
    {
      id: 'aluminium-bifold-doors',
      title: 'Aluminium Bifold Doors',
      image: img('bifolding_style_aluminium_bifold_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/aluminium-bifold-doors.jpg`),
    },
    {
      id: 'steel-look-french-doors',
      title: 'Steel Look French Doors',
      image: img('bifolding_style_steel_look_french_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/steel-look-french-doors.jpg`),
    },
    {
      id: 'steel-look-bifold-doors',
      title: 'Steel Look Bifold Doors',
      image: img('bifolding_style_steel_look_bifold_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/steel-look-bifold-doors.jpg`),
    },
    {
      id: 'upvc-french-doors',
      title: 'uPVC French Doors',
      image: img('bifolding_style_upvc_french_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/upvc-french-doors.jpg`),
    },
    {
      id: 'upvc-sliding-doors',
      title: 'uPVC Sliding Doors',
      image: img('bifolding_style_upvc_sliding_doors', `${BASE_URL}/bifolding-sliding-french-doors/styles/upvc-sliding-doors.jpg`),
    },
  ],

  verandas: [
    {
      id: 'panoramic',
      title: 'Panoramic',
      image: img('veranda_substyle_panoramic', 'https://placehold.co/292x246?text=Panoramic'),
    },
    {
      id: 'panoramic-plus',
      title: 'Panoramic Plus',
      image: img('veranda_substyle_panoramic_plus', 'https://placehold.co/292x246?text=Panoramic+Plus'),
    },
    {
      id: 'slimline',
      title: 'Slimline',
      image: img('veranda_substyle_slimline', 'https://placehold.co/292x246?text=Slimline'),
    },
    {
      id: 'insulated',
      title: 'Insulated',
      image: img('veranda_substyle_insulated', 'https://placehold.co/292x246?text=Insulated'),
    },
  ],

  'verandas-pergolas': [
    {
      id: 'veranda',
      title: 'Veranda',
      image: img('verandas_pergolas_type_veranda', `${BASE_URL}/verandas-pergolas/types/veranda.jpg`),
    },
    {
      id: 'pergola',
      title: 'Pergola',
      image: img('verandas_pergolas_type_pergola', `${BASE_URL}/verandas-pergolas/types/pergola.jpg`),
    },
  ],
};

// Helper function to get style options for a product
export const getStyleOptionsForProduct = (productId) => {
  return styleOptions[productId] || [];
};
